<div class="card-bx stacked">
  <div class="card-background">
    <div class="overlay-circle"></div>
    <div class="arc-container">
      <div class="arc arc1"></div>
      <div class="arc arc2"></div>
      <div class="arc arc3"></div>
    </div>

    <!-- Skeleton Loading State -->
    <div class="card-info text-white" *ngIf="!wallet">
      <div class="skeleton skeleton-text skeleton-sm mb-1"></div>
      <div class="skeleton skeleton-text skeleton-lg mb-sm-4 mb-3"></div>
      <div
        class="d-flex align-items-center justify-content-between mb-sm-5 mb-3"
      >
        <div class="skeleton skeleton-dot"></div>
        <div class="skeleton skeleton-text skeleton-md"></div>
      </div>
      <div class="d-flex">
        <div class="me-5">
          <div class="skeleton skeleton-text skeleton-xs mb-1"></div>
          <div class="skeleton skeleton-text skeleton-sm"></div>
        </div>
        <div class="me-5">
          <div class="skeleton skeleton-text skeleton-xs mb-1"></div>
          <div class="skeleton skeleton-text skeleton-sm"></div>
        </div>
        <div>
          <div class="skeleton skeleton-text skeleton-xs mb-1"></div>
          <div class="skeleton skeleton-text skeleton-md"></div>
        </div>
      </div>
    </div>

    <!-- Actual Content -->
    <div class="card-info text-white" *ngIf="wallet">
      <p class="mb-1 text-white">
        {{ 'features.dashboard.cards.mainBalance' | translate }}
      </p>
      <h2 class="fs-36 text-white mb-sm-4 mb-3">
        {{
          wallet.availableBalance
            | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
        }}
      </h2>
      <div
        class="d-flex align-items-center justify-content-between mb-sm-5 mb-3"
      >
        <img src="assets/images/dual-dot.png" alt="" class="dot-img" />
        <h4 class="fs-20 text-white mb-0">
          {{
            wallet.recipient?.document
              ? (wallet.recipient?.document ?? '' | document : true)
              : (wallet.domain?.document ?? '' | document : true)
          }}
        </h4>
      </div>
      <div class="d-flex">
        <div class="me-5">
          <p class="fs-14 mb-1 text-white op6">
            {{ 'features.dashboard.cards.pendingBalance' | translate }}
          </p>
          <span>{{
            wallet.pendingBalance
              | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
          }}</span>
        </div>
        <div class="me-5">
          <p class="fs-14 mb-1 text-white op6">
            {{ 'features.dashboard.cards.withheldBalance' | translate }}
          </p>
          <span>{{
            wallet.withheldBalance
              | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
          }}</span>
        </div>
        <div>
          <p class="fs-14 mb-1 text-white op6">
            {{ 'features.dashboard.cards.cardHolder' | translate }}
          </p>
          <span>
            {{
              wallet.recipient?.name || wallet.domain?.name
                ? ((
                    wallet.recipient?.name ?? wallet.domain?.name
                  )?.toUpperCase() | reduceName : 32)
                : ('-' | reduceName : 32)
            }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="withdrawal && wallet">
    <a
      href="javascript:void(0)"
      class="d-flex flex-column align-items-center text-decoration-none"
      style="line-height: 1"
      (click)="openNewWithdrawalModal()"
    >
      <i class="fa fa-caret-down" aria-hidden="true"></i>

      <span class="text-black" style="font-size: 12px; margin-bottom: -4px">{{
        'withdrawals.new.title' | translate
      }}</span>
    </a>
  </div>
</div>
